export default __webpack_public_path__ + "static/media/materials.44fb5772.svg";